import { AppConfig } from "./models/env-config.model";
import { EnvConfigProvider } from "./env-config.provider";
import { SourceType } from "../core.types";
import { ServiceLocator } from "app/locator.service";

export abstract class BaseWebApiService {
	protected envConfigProvider: EnvConfigProvider;
	private appConfig: AppConfig;

	constructor() {
		this.envConfigProvider = ServiceLocator.injector.get(EnvConfigProvider);
		this.appConfig = this.envConfigProvider.config;
	}

	protected getFullUrl(partialUrl: string, drupalEndpoint = false): string {
		let host = this.appConfig.apiHost;
		if (drupalEndpoint) {
			host = this.appConfig.drupalHost;
		}
		return `${host}${partialUrl}`;
	}

	protected fullUrl(partialUrl: string, source: SourceType = "zeus"): string {
		let host = "";

		switch (source) {
			case "drupal":
				host = this.appConfig.drupalHost;
				break;
			case "zeus":
				host = this.appConfig.apiHost;
				break;
			case "local":
				break;
		}

		return `${host}${partialUrl}`;
	}

	protected valueReplacer(url: string, strs: string[], values: string[]) {
		let retVal = url;

		strs.forEach((s, i) => {
			retVal = retVal.replace(`{${s}}`, values[i]);
		});

		return retVal;
	}
}
